import React from "react";
import { useSessionstorageState } from "rooks";

import { useUser } from "../contexts/user";
import { SESSION_STORAGE_KEYS } from "../constants";

export default function useProfile() {
  const { user, updateUser } = useUser();
  const [hasSelectedProfile, setHasSelectedProfile] = useSessionstorageState(
    SESSION_STORAGE_KEYS.HAS_SELECTED_PROFILE,
    false,
  );

  React.useEffect(() => {
    if (!user?.isLoggedIn) {
      setHasSelectedProfile(false);
    }
  }, [setHasSelectedProfile, user?.isLoggedIn]);

  const selectedProfile = user?.classrooms?.find(
    (profile) => profile.id === user?.selectedClassroomId,
  );

  const selectProfile = React.useCallback(
    (profileId, options = {}) => {
      const { onSuccess = () => {}, ...rest } = options;
      updateUser(
        { selectedClassroomId: profileId },
        {
          onSuccess: () => {
            setHasSelectedProfile(true);
            onSuccess();
          },
          ...rest,
        },
      );
    },
    [setHasSelectedProfile, updateUser],
  );

  return {
    profile: selectedProfile,
    hasSelectedProfile,
    selectProfile,
  };
}
